import JobBlocks from '@/features/job-blocks/components/job-blocks';
export * from './types';

export default JobBlocks;
